import React from 'react';

const AppConfigContext = React.createContext({});

export default AppConfigContext;
